import createTaskAction from '@esentai/core/ducks/tasks/createTaskAction';

import { CREATE_BRAND } from './types';

export const createBrand = createTaskAction(CREATE_BRAND);
